import { useUserQuery } from '@/components/Form/graphql/queries/generated/user';
import { UserFragment } from '@/graphql/fragments/generated/User';

const useUser = (id?: string | null, pause?: boolean, crossSubWorkspace?: boolean) => {
  const [{ data, fetching, error, stale }] = useUserQuery({
    variables: { filters: { userId: id, crossSubWorkspace } },
    pause: pause || !id,
  });

  return {
    user: data?.user as UserFragment | undefined,
    fetching,
    error,
    stale,
  };
};

export default useUser;
